// Month based on 1 - 12 format.
const JULY = 7;

const endOfSchoolYear = (date = new Date()) => {
  // Add 1 because getMonth returns the month number between 0 - 11.
  const currentMonth = date.getMonth() + 1;
  const currentYear = date.getFullYear();
  const yearEnd = currentMonth < JULY ? currentYear : currentYear + 1;

  return new Date(`${yearEnd}-06-30T23:59:59`);
};

export default endOfSchoolYear;
